import { ToggleButton } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import pfLogo from "@/assets/pf-logo.png";
import { useGlobalPermissions } from "@/domain/usersAndProjects/queryHooks";
import { useAuth } from "@/providers/authProvider";

import { CreateProofingTitle } from "../CreateProofingTitle/CreateProofingTitle.tsx";
import { ThemeModeToggle } from "../ThemeModeToggle.tsx";
import { UserAvatarAndMenu } from "../UserAvatarAndMenu";
import {
  ActionsContainer,
  LogoContainer,
  MainContainer,
  StyledToggleButtonGroup,
} from "./header.styles.ts";

interface HeaderProps {
  showThemeModeToggle?: boolean;
}

const Header = ({ showThemeModeToggle = false }: HeaderProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useAuth();

  // Fetch global permissions to check access_create_page
  const { permissions } = useGlobalPermissions();
  const canCreateTitle = permissions?.access_create_page ?? false;
  const isSupplier = permissions?.is_supplier;

  // Determine current view from URL - default to "your-titles"
  const view = searchParams.get("titles") === "all" ? "all-titles" : "your-titles";

  const handleViewChange = (_event: React.MouseEvent<HTMLElement>, newView: string | null) => {
    if (newView !== null) {
      const newParams = new URLSearchParams(searchParams);

      if (newView === "all-titles") {
        newParams.set("titles", "all");
      } else {
        newParams.delete("titles"); // Remove param for default "your-titles"
      }

      setSearchParams(newParams);
    }
  };

  return (
    <MainContainer data-testid="header-main-container">
      <LogoContainer component="a" href="/">
        <img src={pfLogo} alt="Proofing Logo" style={{ height: "32px", width: "auto" }} />
      </LogoContainer>

      {!isSupplier && (
        <StyledToggleButtonGroup
          value={view}
          exclusive
          onChange={handleViewChange}
          aria-label="title view"
        >
          <ToggleButton value="your-titles" aria-label="your titles">
            Your titles
          </ToggleButton>
          <ToggleButton value="all-titles" aria-label="all titles">
            All titles
          </ToggleButton>
        </StyledToggleButtonGroup>
      )}
      <ActionsContainer>
        {showThemeModeToggle && <ThemeModeToggle />}
        {canCreateTitle && <CreateProofingTitle />}
        {user && <UserAvatarAndMenu user={user} />}
      </ActionsContainer>
    </MainContainer>
  );
};

export default Header;
